let accountDetails = null;

export const setAccountDetails = (details) => {
  accountDetails = details;
};

export const getAccountDetails = () => accountDetails;
